import React from 'react'
import { MODEL_TYPE } from '@trustero/trustero-api-web/lib/common/model_pb'
import { Control } from '@trustero/trustero-api-web/lib/model/control_pb'
import { TabType } from '../../../../components/Reusable/Tabs'
import { Spinner } from '../../../../Throbber'
import { useEvidenceGenerators } from '../../../../components/async/attachment/useEvidenceGenerators'
import { TabBody } from './TabBody'
import { TabNote } from './TabNote'

export const useConnectedTab = ({
  control,
}: {
  control: Control.AsObject
}): TabType => {
  const response = useEvidenceGenerators({
    modelType: MODEL_TYPE.CONTROL,
    modelId: control.id,
    connected: true,
  })
  const count = response.data?.getItemsList().length ?? (
    <Spinner size="s" color="primary" />
  )

  return {
    title: 'Automated evidence',
    count,
    note: <TabNote control={control} />,
    body: (
      <TabBody
        controlId={control.id}
        evidenceGenerators={response.data?.getItemsList() ?? []}
      />
    ),
  }
}
